export const LINE_TYPES = {
  METERED: 'METERED',
  UNLIMITED: 'UNLIMITED',
};

export const LINE_TYPES_OPTIONS = {
  1: LINE_TYPES.UNLIMITED,
  2: LINE_TYPES.METERED,
};
